import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=780112f6&scoped=true&"
import script from "./Tab.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Tab.vue?vue&type=script&scoped=true&lang=js&"
import style1 from "./Tab.vue?vue&type=style&index=1&id=780112f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780112f6",
  null
  
)

export default component.exports